/* eslint-disable @typescript-eslint/no-explicit-any */
import { loginSlice } from "../../services/http";

export const authApi = loginSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials: {
        email: string;
        password: string;
        token: string;
      }) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
    }),
    loginKeycloak: builder.mutation({
      query: (token: string) => ({
        url: "/auth/login/keycloak",
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getDevUsers: builder.query<
      { email: string; name: string; description: string }[],
      void
    >({
      query: () => ({
        url: "/auth/dev-users",
        method: "GET",
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useLoginMutation, useLoginKeycloakMutation, useGetDevUsersQuery } = authApi;

export const {
  endpoints: {
    login: { select: selectLogin },
  },
} = authApi;
